import { Reveal, ChapterLabel } from "./primitives";
import { GALLERY } from "../../data/site";

export const Gallery = () => {
  return (
    <section
      id="galleria"
      data-testid="gallery-section"
      className="relative bg-[#0A0A0A] px-5 py-24 md:px-10 md:py-32"
    >
      <div className="mx-auto max-w-[1400px]">
        <ChapterLabel number="04" title="La galleria" />

        <div className="grid grid-cols-2 gap-px bg-white/10 md:grid-cols-4 md:grid-rows-2">
          {GALLERY.map((g, i) => (
            <Reveal
              key={i}
              delay={(i % 4) * 0.06}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden bg-[#0A0A0A] ${
                i === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <div className={`${i === 0 ? "h-64 md:h-full" : "h-40 md:h-full md:min-h-[260px]"}`}>
                <img
                  src={g.url}
                  alt={g.caption}
                  loading="lazy"
                  className="h-full w-full object-cover grayscale transition-all duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/90 via-transparent to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-40" />
              <span className="absolute bottom-4 left-4 translate-y-2 font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#FAFAFA] opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                {g.caption}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
